// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610071438/js/" + chunkId + "." + {"44":"2edb7c9e","225":"eff707b1","481":"4ef90e4d","486":"b84616d9","770":"5d554342"}[chunkId] + ".0.7288074479589409.chunk.js";
};